import * as main            from "../main";
import * as moment          from "moment";
import * as timeinterval    from "../timeinterval";
import * as grid from "../grid";

let LABEL_ETooManyDays = "";
let dateTimeErrorMessageLabel = "";

export function initialize(ETooManyDays: string, dateTimeErrorMessage: string): void {
    LABEL_ETooManyDays = ETooManyDays;
    dateTimeErrorMessageLabel = dateTimeErrorMessage;

    main.setHideDiv("errorMessage", false);
    main.setHideDivBootstrap("periodSelector", false);
    grid.loadGridOptions("UserHistoryGrid");
    searchButtonClicked();
}

export function searchButtonClicked(): void {
    $("#SearchButtonLoader").show();

    main.setHideDiv("DivLblTooMany", false);
    main.setHideDiv("DivLblTooMany", false);
    main.setHideDiv("errorMessage", false);

    const selectedInterval = parseInt($("#TimeIntervalID").data("kendoDropDownList").value());
    let from = timeinterval.getBeginPeriodSelection(selectedInterval, null);
    let to = timeinterval.getEndPeriodSelection(selectedInterval, null);

    if (from != null && to != null) {
        const grid = $("#UserHistoryGrid").data("kendoGrid");
        if (grid != null && grid != undefined) {
            grid.pager.dataSource.page(1);
            grid.dataSource.read();
        }
    }
    else {
        $("#SearchButtonLoader").hide();
        // make a message
        main.setHideDiv("errorMessage", true);

        const lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}

export function getAdditionalData(): { timestampFrom: Date, timestampTo: Date, page: number } {

    // defaults
    const beginDateTime = moment();
    let toLocal = new Date(beginDateTime.unix() * 1000);
    let fromLocal = new Date(beginDateTime.subtract(1, 'days').unix() * 1000);

    // timeinterval
    const ddl = $("#TimeIntervalID").data("kendoDropDownList");
    if (ddl != null && ddl != undefined) {
        const ddlval = parseInt(ddl.value());
        fromLocal = timeinterval.getBeginPeriodSelection(ddlval, null);
        toLocal = timeinterval.getEndPeriodSelection(ddlval, null);

        const tsDays = (toLocal.getTime() - fromLocal.getTime()) / (1000 * 3600 * 24);
        if (tsDays >= 33) {

            // make a message
            main.setHideDiv("DivLblTooMany", true);

            const lblEmsg = $("#LblTooMany");
            if (lblEmsg != null && lblEmsg != undefined) {
                lblEmsg.text(LABEL_ETooManyDays);
            }

            fromLocal = toLocal = new Date(Date.now());
        }
    }

    return {
        timestampFrom: fromLocal,
        timestampTo: toLocal,
        page: 1
    };
}
